module.exports = __webpack_public_path__ + "img/sustainability@2x.2937149.webp";